import { Injectable } from "@angular/core";
import { Message } from "primeng/api";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MessagesService {
  private messageSource = new BehaviorSubject<Message>({ severity: "", summary: "", detail: "" });
  currentMessage = this.messageSource.asObservable();

  constructor() {}

  changeMessage(message: Message) {
    this.messageSource.next(message);
  }
}
